export const downloadFile = async (url: string, filename: string, options?: RequestInit) => {
  try {
    const response = await fetch(url, options);

    // Handle signed-url JSON response (used for large files like CSVs and PDFs)
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const json = await response.json();
      if (json.type === 'signed-url' && json.url) {
        const fileResponse = await fetch(json.url);
        const blob = await fileResponse.blob();
        triggerDownload(blob, json.filename || filename);
        return;
      }
    }

    const blob = await response.blob();
    triggerDownload(blob, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

const triggerDownload = (blob: Blob, filename: string) => {
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(blobUrl);
};
